import React from 'react'
import Style from './IncidentFeed.module.css'
import TrendPanel from './TrendPanel'
import ComingSoon from './ComingSoon'

// Daily activity grid (PIXMC-6521).
//
// The container is owned by this story; PIXMC-6503 fills the middle panel with real
// Policy violations data. Until then it is a Coming Soon placeholder of the same
// footprint (D-9), so swapping it in later reflows nothing.
//
// ⚠️ This panel's phishing total will NOT match the ring's centre total, by design, and
// since 2026-10-12 (PIXMC-6442 D-18) for THREE reasons rather than one. Do not try to
// reconcile them:
//
//   1. the series excludes Verified Phish while the ring counts it. WS-0 measured
//      feed-sourced rows at ~76% of the Prod donut, all of which land in Verified Phish,
//      so this term alone is large in Production;
//   2. the series includes Type 4 (google_form_phish) and the ring does not;
//   3. the ring includes verified Type 3 (reported_phish) and the series does not.
//
// The old identity (ring total − Verified Phish === series total) is RETIRED; it held
// only while both endpoints read the same event types, which they deliberately no longer
// do. Stated on the QA ticket so none of this is raised as a defect.
const DailyActivityGrid = ({
  windowLabel,
  phishingDetections,
  phishingDetectionsLoading,
  phishingDetectionsError,
  pagesScanned,
  pagesScannedLoading,
  pagesScannedError,
}) => {
  const subtitle = (total, suffix) =>
    `${Number(total || 0).toLocaleString()} ${suffix} · ${windowLabel.toLowerCase()}`

  return (
    <div className={Style.card}>
      <div className={Style.cardHeader}>
        <div className={Style.cardTitle}>
          Daily activity
          <span className={Style.cardSub}>each panel on its own scale</span>
        </div>
      </div>
      <div className={Style.trendGrid}>
        <TrendPanel
          name="Phishing detections"
          subtitle={subtitle(phishingDetections.totalRecords, 'total')}
          records={phishingDetections.records}
          loading={phishingDetectionsLoading}
          error={phishingDetectionsError}
          emptyText="No phishing detections"
          formatValue={(v) =>
            `${Number(v || 0).toLocaleString()} ${Number(v) === 1 ? 'detection' : 'detections'}`
          }
        />

        <ComingSoon
          variant="panel"
          label="Policy violations"
          note="Daily policy violation activity will appear here."
          ticket="PIXMC-6503"
        />

        <TrendPanel
          name="Pages scanned"
          subtitle={subtitle(pagesScanned.totalRecords, 'total')}
          records={pagesScanned.records}
          loading={pagesScannedLoading}
          error={pagesScannedError}
          emptyText="No login pages scanned"
          formatValue={(v) => `${Number(v || 0).toLocaleString()} pages scanned`}
        />
      </div>
    </div>
  )
}

export default DailyActivityGrid
